import React, { useState, useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import classNames from 'classnames';
import Input from '../../../components/ModalForm/Input';
import RoundButton from '../../../components/RoundButton';
import slugify from '../../../utils/slugify';
import { Context } from '../../../context/AppContext';
import ArticleCategorySuggest from '../../../components/AutoSuggest/ArticleCategorySuggest';

const StyledCategorySearchRoot = styled(Container)`
  width: 790px;
  position: relative;
  top: 42px;

  @media (max-width: 1024px) {
    width: 100%;
    max-width: 650px;
    margin-left: 20px;
    margin-right: 20px;
  }

  @media (max-width: 767px) {
    top: 0;
  }
`;

const StyledCategorySearchWrapper = styled(Container)`
  box-shadow: 0 2px 8px 0 rgb(0 0 0 / 40%);
  border-radius: 40px;
  background: #fff;
  padding: 15px;
  margin: 0 auto;
  width: 100%;

  form {
    width: 100%;
    align-items: center;
    display: flex;
  }

  input {
    width: 100%;
    height: 100%;
    border: none;
    padding: 12px 15px 12px 50px;
    font-size: 22px;
  }

  .AutoSuggest__Wrapper__root {
    width: 100%;
  }

  .ModalForm__Input__wrapper {
    margin: 0;
  }

  i {
    width: 50px;
    font-size: 40px;
    left: 3px;
  }

  .Guides__CategorySearch__SearchButton.RoundButton__root.RoundButton__root--blue {
    background-color: ${props => props.theme.primary.normal};
    height: 50px;
    border: none;
    border-radius: 50px;
    width: 110px;
  }

  @media (max-width: 767px) {
    padding: 0;

    &.Guides__CategorySearch__Wrapper--focused {
      border-radius: 30px 30px 0 0;
    }

    .AutoSuggest__Wrapper__input,
    .ModalForm__Input__input {
      border-radius: 30px;
      font-size: 18px;
      padding-left: 50px;
      padding-right: 30px;
    }

    .AutoSuggest__Wrapper__List__root {
      top: 47px;
      box-shadow: 0 9px 8px 0 rgb(0 0 0 / 40%);
      border-radius: 0 0 30px 30px;
      border: none;
    }

    .AutoSuggest__Wrapper__icon,
    .ModalForm__Input__icon {
      left: 8px;
      color: ${props => props.theme.text.normal};
    }

    .Guides__CategorySearch__SearchButton {
      display: none;
    }
  }
`;

const CategorySearch = () => {
  const { media: { mobile } = {} } = useContext(Context) || {};
  const history = useHistory();
  const [category, setCategory] = useState('');
  const [hasResults, setHasResults] = useState();

  const onSubmit = useCallback(() => {
    if (category) {
      if (window) {
        history.push(`/guides/${slugify(category)}`);
      }
    }
  }, [category]);

  const onClickSuggest = useCallback(
    formatted => {
      setCategory(formatted);
      if (formatted && mobile) {
        if (window) {
          history.push(`/guides/${slugify(formatted)}`);
        }
      }
    },
    [mobile]
  );

  return (
    <StyledCategorySearchRoot className="Guides__CategorySearch">
      <StyledCategorySearchWrapper
        className={classNames('Guides__CategorySearch__Wrapper', {
          'Guides__CategorySearch__Wrapper--focused': hasResults,
        })}
      >
        <form>
          <ArticleCategorySuggest
            limit={10}
            minLength="2"
            icon="icon-generalsearchlarge"
            onClickSuggest={({ formatted }) => {
              onClickSuggest(formatted);
            }}
            onListShow={val => {
              setHasResults(val);
            }}
            onChange={e => {
              setCategory(e.target.value);
            }}
          >
            <Input
              type="text"
              value={category || ''}
              minLength="2"
              placeholder="Search by category"
              icon="icon-generalsearchlarge"
              readOnly
            />
          </ArticleCategorySuggest>
          <RoundButton
            theme="blue"
            type="button"
            className="Guides__CategorySearch__SearchButton"
            onClick={() => onSubmit()}
          >
            Search
          </RoundButton>
        </form>
      </StyledCategorySearchWrapper>
    </StyledCategorySearchRoot>
  );
};

export default CategorySearch;
